import * as Sentry from "@sentry/react";

function isInIframe(): boolean {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}

function getParentDomain(): string {
  try {
    if (import.meta.env.DEV) {
      try {
        if (window.parent?.location && window.parent !== window) {
          return new URL(window.parent.location.href).hostname;
        }
      } catch {
        // Cross-origin
      }
    }

    if (window.location.ancestorOrigins?.length > 0) {
      return new URL(window.location.ancestorOrigins[0]).hostname;
    }
    if (document.referrer) {
      return new URL(document.referrer).hostname;
    }
    return "unknown";
  } catch {
    return "unknown";
  }
}

export function initializeIframeTelemetry(): void {
  if (!isInIframe()) {
    return;
  }

  const parentDomain = getParentDomain();

  Sentry.addBreadcrumb({
    category: "iframe.load",
    message: `Widget loaded from: ${parentDomain}`,
    level: "info",
    data: { domain: parentDomain },
  });
}
